"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dots;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Dots() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cmeter__dots"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 165 120"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "10",
    cy: "60",
    r: "10",
    className: "circle-move-up-down"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "82",
    cy: "60",
    r: "10",
    className: "circle-mid-move-up-down"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "155",
    cy: "60",
    r: "10",
    className: "circle-move-up-down"
  }))));
}